export default function ConfigStore(vm) {
    this.create = function(params) {
        var url = '/config/store/create';

        return vm.post(url, params);
    };

    this.get = function() {
        var url = '/config/store/detail';

        return vm.get(url);
    };
}